export default __webpack_public_path__ + "static/media/cp-documentCenter.fc3214dd.png";